module.exports = __webpack_public_path__ + "static/media/KeeperTeamsSVG.cae90305.svg";